import React, { Fragment, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { PageHeadingContext, Helmet } from "@osu/react-ui";
import { useLocation, useParams } from 'react-router-dom';
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";
import LoadingSpinner from "../../Common/components/LoadingSpinner";
import ProtectedRoute from './ProtectedRoute';

export function RenderableView(props = defaultProps) {
    const location = useLocation()
    const params = useParams()
    const { Component, noIndex, title: pathTitle, titleProps, authRequired, requiresAdminAccess, ...rest } = props
    const { setHeading, setOptions } = useContext(PageHeadingContext)
    const { isLoggedIn } = useRoleAuthentication();
    
    const title = !isLoggedIn ? "Loading..."
        : typeof pathTitle === 'function'
            ? pathTitle({ location, params }) 
            : pathTitle;

    useEffect(() => {   
        title && setHeading(title)
    }, [setHeading, title])

    useEffect(() => {    
        if(titleProps) {
            setOptions(titleProps)
        }
    }, [setOptions, titleProps])

    if (!isLoggedIn) { 
        return <LoadingSpinner isFetching={true} count={1} height={"10rem"} />; 
    }
    
    return <Fragment>
        {(noIndex || authRequired) && <Helmet>
            <meta id="meta-hidden" name="robots" content="noindex" />
        </Helmet>}
        <ProtectedRoute requiresAdminAccess={requiresAdminAccess}>
            <Component {...rest} />
        </ProtectedRoute>
    </Fragment>
}

const defaultProps = {
    noIndex: false, 
    authRequired: false,
    requiresAdminAccess: false
}

RenderableView.propTypes = {
    path: PropTypes.string.isRequired, 
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired, 
    titleProps: PropTypes.object, 
    Component: PropTypes.oneOfType([PropTypes.element, PropTypes.object, PropTypes.func]).isRequired, 
    noIndex: PropTypes.bool, 
    authRequired: PropTypes.bool,
    requiresAdminAccess: PropTypes.bool
}

export default RenderableView